module.exports = __webpack_public_path__ + "static/media/menu.be3be65f.svg";